import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../utils/translations';
export function GuaranteeSection() {
  const {
    language
  } = useLanguage();
  const t = translations[language].guarantee;
  return <section className="py-20 px-4 bg-gradient-to-b from-black to-teal-950" data-id="element-211">
      <div className="max-w-4xl mx-auto" data-id="element-212">
        <div className="bg-gradient-to-br from-teal-950/50 to-black border-2 border-teal-600/50 rounded-2xl p-8 md:p-12" data-id="element-213">
          <div className="flex items-center justify-center gap-3 mb-6" data-id="element-214">
            <ShieldCheckIcon className="w-12 h-12 text-teal-400" data-id="element-215" />
            <h2 className="text-3xl md:text-4xl font-bold text-teal-400" data-id="element-216">
              {t.title}
            </h2>
          </div>
          <div className="space-y-6 text-lg text-gray-200 leading-relaxed" data-id="element-217">
            <p data-id="element-218">
              {t.text}{' '}
              <span className="text-yellow-400 font-semibold" data-id="element-219">{t.email}</span>{' '}
              {t.text2}
            </p>
            <div className="bg-teal-950/50 border border-teal-600/30 rounded-xl p-6 text-center" data-id="element-220">
              <p className="text-2xl font-bold text-yellow-400" data-id="element-221">
                {t.highlight}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}